import { render, staticRenderFns } from "./StartPreview.vue?vue&type=template&id=cf2740d4&"
import script from "./StartPreview.vue?vue&type=script&lang=js&"
export * from "./StartPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports